import { useEffect, useState } from "react";

export type Breakpoint = "mobile" | "tablet" | "desktop";

// Tailwind's md (768px) and xl (1280px) screens.
const MOBILE_QUERY = "(max-width: 767px)";
const TABLET_QUERY = "(max-width: 1279px)";

const readBreakpoint = (): Breakpoint => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function")
    return "desktop";
  if (window.matchMedia(MOBILE_QUERY).matches) return "mobile";
  if (window.matchMedia(TABLET_QUERY).matches) return "tablet";
  return "desktop";
};

/**
 * The viewport's size class: phones, tablets and narrow laptops, desktops.
 * Read on first render, so the first paint already has the right layout.
 */
export const useBreakpoint = (): Breakpoint => {
  const [breakpoint, setBreakpoint] = useState(readBreakpoint);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const queries = [MOBILE_QUERY, TABLET_QUERY].map((query) =>
      window.matchMedia(query),
    );
    const update = () => setBreakpoint(readBreakpoint());
    queries.forEach((query) => query.addEventListener("change", update));
    return () =>
      queries.forEach((query) => query.removeEventListener("change", update));
  }, []);

  return breakpoint;
};
